<template>
<div class="center-warp">
  <div class="inner design-warp">
    <div class="d-flex" style="align-items: center;justify-content: flex-end">
      <div class="add-card-data"><span>{{ caseDetail.confirm_first_case_type_text ? '确认套餐类型' : '期望套餐类型' }}：</span><span class="black-14">{{ caseDetail.confirm_first_case_type_text ? caseDetail.confirm_first_case_type_text : caseDetail.first_case_type_name }}</span></div>
    </div>
    <div class="design-img-outer">
      <img class="design-img" :src="addOption.shejidan_img" alt="">
      <Zwibbler :bottom="'80px'"  :dataInfo1="caseDetail" ref="zwibbler" :width="916" :height="1243"></Zwibbler>
    </div>
    <div class="design-btn-outer">
      <div class="design-btn black-14" @click="submitAdd">提交</div>
    </div>
  </div>
</div>
</template>

<script>
import {CreateCaseCard, GetCaseInfo, GetListByTypeCode} from "@/http/api";
// import Sign from '@/components/Sign'
import Zwibbler from '@/components/Zwibbler'
import ossUpload from "@/http/ossUpload";


export default {
  name: "add_designCard",
  components: {Zwibbler},
  data(){
    return{
      addOption:{
        shejidan_type:'',
        shejidan_img:'',
        type_id:5,
        shejidan_order_no:'',
        patient_id:''
      },
      caseDetail:'',
    }
  },
  mounted() {
    this.$store.commit('breadChange',{name:'新建设计单',isBack:false})
    this.initData()
  },
  methods:{
    initData(){
      let _that = this
      let query = this.$route.query
      GetListByTypeCode({type_code: ['shejidanmoban']}).then(res => {
        res.data.shejidanmoban.forEach(item=>{
          if(item.id == query.shejidan_id){
            _that.addOption.shejidan_type = item.item_value
            _that.addOption.shejidan_img = item.item_comment
            _that.addOption.imgSrc = item.item_comment
          }
        })
      })
      this.addOption.patient_id = query.patient_id
      GetCaseInfo({id: query.patient_id}).then(res => {
        this.caseDetail = res.data
      })
      console.log(this.addOption)
    },
    submitAdd(){
      let blob = this.$refs.zwibbler.saveTu()
      ossUpload.bucketUpload(blob, (res) => {
        this.addOption.pizhu_img = res.url
        CreateCaseCard(this.addOption).then(res=>{
          if(res.code == 200){
            this.$message({
              type:'success',
              message:'新建成功'
            })
            if(this.$route.query.from){
              let url = this.$route.query.from + '&designId=' + res.data.id
              window.location.href = url
            }else{
              this.$router.push({
                name:'病历管理',
                params:{
                  id:this.$store.state.designOption.patient_id,
                  card_id:res.data.id
                }
              })
            }
          }else{
            this.$message({
              type:'error',
              message:res.message[0]
            })
          }
        })
      }, (err) => {
        this.$message({
          type: "error",
          message: '上传失败'
        })
      }, 'duole-images', '/upload/image/pc/')

    },
  }
}
</script>

<style scoped src="../../assets/css/case_management_add_case.css"></style>
<style scoped>
.add-data-item-input {
  position: relative;
}
.add-data-item-input input{
  width: 176px;
  height: 34px;
  background: #F4F4F4;
  border-radius: 8px;
  padding: 0 10px;
  font-size: 14px;
  border: none;
  padding-left: 10px !important;
}
.add-data-item-input .el-input__prefix{
  left: 150px;
  top: -2px;
}
.add-data-item-input .el-icon-arrow-right{
  color: #B1B1B1;
  font-size: 12px;
  font-weight: bold;
}
.add-data-item-input .icon-youjiantou{
  position: absolute;
  right: 10px;
  color: #B1B1B1;
  font-size: 10px;
  top: 8px;
  font-weight: bold;
}
.add-data-item-input input::placeholder{
  color: rgba(60,60,67,0.3);
}
.add-data-item-input input:focus{
  background: rgba(254,212,0,0.05);
  border: 1px solid #FED400;
}
</style>
